/**
 * The customer upload contract shared by the API Worker and the customer app
 * (spec 2026-09-26, section 9): signed signature pages, the Form 7004 proof
 * and mailing proof all post multipart with each file under this one key,
 * repeated once per file. The API reads no other key.
 */
export const SIGNED_UPLOAD_FILE_FIELD = "files[]";
